import { HttpMethod } from "src/constants/http-method";
import { API_ONE_CLICK_NEWSLETTER_SUBSCRIPTION } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";

interface IResponse {
    isSuccess: boolean;
}

export function useOneClickEmailSubscribtion() {
    const { mutatePromise } = useMutation<IResponse, void, void>(API_ONE_CLICK_NEWSLETTER_SUBSCRIPTION, { method: HttpMethod.POST });
    return mutatePromise;
}
